<div class="flag-container" (click)="toggleItems()">
    <div class="flex">
        <span class="nav-flag" [ngClass]="'flag_' + selectedItem?.Code"></span>
    </div>
    <div class="selected">
        <span class="body-bold-14">{{selectedItem?.Code}}</span>
        <div class="arrow-container">
            <span [ngClass]="showSelect ? 'arrow-dropdown-up' : 'arrow-dropdown'"></span>
        </div>
    </div>
</div>
<div class="app-select" *ngIf="showSelect">
    <div class="select-item" *ngFor="let item of Items" (click)="selectItem(item)">
        <span class="nav-flag" [ngClass]="'flag_' + item.Code"></span>
        <span class="caption12">{{item.Name}}</span>
    </div>
</div>
